import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDsILOSKmO2GY7AwMIeZNjaUNkJhBttFag",
  authDomain: "hb-tec.firebaseapp.com",
  projectId: "hb-tec",
  storageBucket: "hb-tec.appspot.com",
  messagingSenderId: "416914585641",
  appId: "1:416914585641:web:179ca3a8da7047b1be8438",
  measurementId: "G-JRX3Y9QQ7F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
